import * as IF from "infrontjs";
import template from "./template.html";

/**
 * <bottom-nav> — the guest-app's floating 5-tab bar.
 *
 * Every tab routes to a tab-state. The drawer used to sit here as a fifth
 * "Menü" tab and now lives in <top-menu>: a tab bar is for the places a guest
 * moves BETWEEN, and the drawer is not one of them — it is chrome. Giving the
 * slot back bought the Region tab, which is content.
 *
 * Routes are kept as literals here (matching each tab state's ROUTE) so the
 * component has no state imports. The View drives `setActive()` / `setHidden()`
 * from the active state after every navigation.
 *
 * The labels are German source strings that double as their dictionary keys —
 * a module constant is evaluated before I18n exists, so the template translates
 * them on the way out.
 */
const TABS = [
    { id: "home",   label: "Home",   icon: "house",          route: "/" },
    // Route stays "/region" — it is what the state, the detail links and any
    // QR code already in a guest's hand resolve to.
    { id: "region", label: "Entdecken", icon: "map-pinned",  route: "/region" },
    { id: "events", label: "Events", icon: "calendar-days",  route: "/events" },
    { id: "plan",   label: "Planer", icon: "route",          route: "/plan" },
    { id: "chat",   label: "Chat",   icon: "message-circle", route: "/chat" }
];

class BottomNav extends HTMLElement
{
    constructor()
    {
        super();
        this._connected = false;
    }

    connectedCallback()
    {
        if ( false === this._connected )
        {
            this.app = IF.App.get();
            this.render();
            this.bind();
            this._connected = true;
        }
    }

    render()
    {
        this.app.view.render( this, template, { tabs: TABS } );
    }

    bind()
    {
        this.querySelectorAll( ".bottomnav__item" ).forEach( ( btn ) =>
        {
            btn.addEventListener( "click", () =>
            {
                const route = btn.getAttribute( "data-route" );
                if ( route )
                {
                    this.app.router.redirect( route );
                }
            } );
        } );
    }

    /** Light the button for the active tab (null clears all). */
    setActive( tabId )
    {
        this.querySelectorAll( ".bottomnav__item" ).forEach( ( btn ) =>
        {
            btn.classList.toggle( "bottomnav__item--active", btn.getAttribute( "data-tab" ) === tabId );
        } );
    }

    /**
     * Show or hide the unread dot on one tab.
     *
     * A dot, not a count: the only thing a guest needs from the tab bar is
     * "there is an answer" — the number is in the conversation.
     *
     * @param {string} tabId
     * @param {boolean} hasUnread
     */
    setUnread( tabId, hasUnread )
    {
        const dot = this.querySelector( '[data-id="dot-' + tabId + '"]' );
        if ( dot )
        {
            dot.hidden = !hasUnread;
        }
    }

    /** Show/hide the whole bar (detail + auth screens hide it). */
    setHidden( hidden )
    {
        this.classList.toggle( "is-hidden", !!hidden );
    }
}

customElements.define( "bottom-nav", BottomNav );
